import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { StoreBadges } from "@/components/StoreBadges";

const GENERATORS = [
  ["Business name generator", "/business-name-generator"],
  ["Brand name generator", "/brand-name-generator"],
  ["App name generator", "/app-name-generator"],
  ["Startup name generator", "/startup-name-generator"],
  ["Company name generator", "/company-name-generator"],
  ["Domain name generator", "/domain-name-generator"],
];

export function Footer() {
  return (
    <footer className="border-t hairline bg-surface mt-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Logo />
            <p className="text-[13px] text-ink-muted mt-3 max-w-[220px] leading-relaxed">
              Find It. Claim It. Make It Yours. AI names, instant .com availability & estimated value.
            </p>
            <p className="overline text-ink-subtle mt-6 mb-2.5">Get the app</p>
            <StoreBadges />
          </div>
          <div>
            <p className="overline text-ink-subtle mb-3">Generators</p>
            <ul className="space-y-2">
              {GENERATORS.map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="text-[13px] text-ink-muted hover:text-ink transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="overline text-ink-subtle mb-3">Product</p>
            <ul className="space-y-2">
              <li><Link to="/generate" className="text-[13px] text-ink-muted hover:text-ink">Generate names</Link></li>
              <li><Link to="/pricing" className="text-[13px] text-ink-muted hover:text-ink">Pricing</Link></li>
              <li><Link to="/saved" className="text-[13px] text-ink-muted hover:text-ink">Saved names</Link></li>
            </ul>
          </div>
          <div>
            <p className="overline text-ink-subtle mb-3">Legal</p>
            <ul className="space-y-2">
              <li><a href="https://namesmith-ai-3.emergent.host/api/legal/terms" className="text-[13px] text-ink-muted hover:text-ink">Terms</a></li>
              <li><a href="https://namesmith-ai-3.emergent.host/api/legal/privacy" className="text-[13px] text-ink-muted hover:text-ink">Privacy</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t hairline flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[12px] text-ink-subtle">© {new Date().getFullYear()} Namable. All rights reserved.</p>
          <p className="text-[12px] text-ink-subtle">Domain values are AI estimates, not appraisals.</p>
        </div>
      </div>
    </footer>
  );
}
